import { render, staticRenderFns } from "./Colours.vue?vue&type=template&id=3fa0a9d1&scoped=true"
import script from "./Colours.vue?vue&type=script&lang=js"
export * from "./Colours.vue?vue&type=script&lang=js"
import style0 from "./Colours.vue?vue&type=style&index=0&id=3fa0a9d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa0a9d1",
  null
  
)

export default component.exports